import { NgModule } from '@angular/core';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { IconsModule } from '@shared/icons/icons.module';
import { InboxListComponent } from './pages/inbox-list/inbox-list.component';
import { InboxRoutingModule } from './inbox-routing.module';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
    declarations: [InboxListComponent],
    imports: [CustomFormModule, InboxRoutingModule, SharedModule, IconsModule, NgxExtendedPdfViewerModule]
})
export class InboxModule {}
